import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["pageView"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/// Helper Functions for adding tracking events to Segment
/// https://segment.com/docs/guides/intro-impl/

/** Legacy shape uses pageView + context; also allows any other properties (e.g. value, source_transaction_id). */

/**
 * Track a Segment event by name with optional properties.
 * Supports both legacy usage (pageView, context for ELEMENT_PRESSED) and
 * specific events with rich properties (numbers, arrays, etc.).
 *
 * Legacy: trackEvent(TrackingEventNames.ELEMENT_PRESSED, { pageView, context, value })
 * Specific: trackEvent(TrackingEventNames.TRANSACTION_CLONE_COMPLETED, { source_transaction_id, num_listings })
 *
 * Note: pageView is sent to Segment as page_view; context and all other properties are sent as-is.
 */
export var trackEvent = function trackEvent(eventName, properties) {
  if (!properties) {
    window.analytics.track(eventName);
    return;
  }
  var pageView = properties.pageView,
    rest = _objectWithoutProperties(properties, _excluded);
  var payload = _objectSpread({}, rest);
  if (pageView !== undefined) {
    payload.page_view = pageView;
  }
  window.analytics.track(eventName, payload);
};